module.exports = __webpack_public_path__ + "img/full7-min.ca372a26.png";